import { Controller } from 'stimulus';

export default class extends Controller {
  addAsTip(event) {
    var $this = $(event.target);
    var loadingText = '<i class="fa fa-circle-o-notch fa-spin"></i>';
    $this.html(loadingText);
    $this.addClass('disabled');
  }

  readMore(event) {
    $(event.target).parent().parent().find(".show-more").removeClass("d-none");
    $(event.target).parent().parent().find(".show-less").addClass("d-none");
  }

  readLess(event) {
    $(event.target).parent().parent().find(".show-less").removeClass("d-none");
    $(event.target).parent().parent().find(".show-more").addClass("d-none");
  }

  loadAudioDiv(event){
    var post_id = $(event.target).parents('a').data("id");
    var audio_container = $(`.audio-div#audio-post-${post_id}`);
    var media_url = $(event.target).parents('a').data("src");

    var video_div = $(`<audio controls ><source src="${media_url}" type="audio/ogg">Your browser does not support the audio element.</audio>`);
    audio_container.append(video_div)

    $(event.target).remove();
  }

  loadIframe(event) {

    var header = $(event.target).parents('div.header');
    var media_url = $(event.target).parents('a').data("media-url");

    if(platform == "tiktok"){
      header.find("i").addClass("d-none");
      header.find(".tiktok-spinner").removeClass("d-none");
    }

    if (media_url){
      $('.post-videos').each(function(i, vid) { $(vid).trigger('pause'); });
      var video_div = $(`<video class='post-videos' controls style='width: 100%; height: 100%;'><source src="${media_url}" type="video/mp4"></video>`);
      header.find("a").addClass("d-none");
      header.append(video_div);

      video_div.trigger('play');

    } else {
      if($("#post-iframe-embed").length > 0) {
        header.find("i").removeClass("d-none");
        header.find(".tiktok-spinner").addClass("d-none");
        $("#post-iframe-embed").parent().find("a").removeClass("d-none");
        $("#post-iframe-embed").remove();
        $(".card-body").removeClass("d-none");
      }

      var src = $(event.target).parents('a').data("src");
      var platform = $(event.target).parents('a').data("platform");

      var iframe = "";
      if(platform == "youtube") {
        if(src.indexOf("autoplay=1") < 0) src += "?autoplay=1";
        var height = $(event.target).parents('a').data("frame-height");
        iframe = $("<iframe id='post-iframe-embed' style='width: 100%; min-height:102px; max-height: 315px;' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>").attr("height", height);
        iframe.attr("src", src);
        header.find("a").addClass("d-none");
        header.append(iframe);


      } else {
        if(platform == "tiktok") var oembed_url = 'https://www.tiktok.com/oembed?url=' + src;
        else if(platform == "facebook") var oembed_url = 'https://graph.facebook.com/v14.0/oembed_video?url=' + src;
        else if(platform == "instagram") var oembed_url = 'https://graph.facebook.com/v14.0/instagram_oembed?url=' + src;
        else if(platform == "twitter") var oembed_url = 'https://publish.twitter.com/oembed?url=' + src;
        this.getEmbedCode(oembed_url, header, platform);
      }

    }
  }

  getEmbedCode(oembed_url, header, platform) {
    $.ajax({
      type: 'POST',
      url: '/posts/embed_code',
      data: { url: oembed_url, platform: platform},
      success: (response) => {
        if(response["success"] == false) {
          header.find("a").removeClass("d-none");
          alert('Error: ' + response["message"]);
        }
        else {
          var iframe = $("<div id='post-iframe-embed'></div>").html(response["html"]);
          if (platform == "tiktok") {
            iframe.addClass("tiktok-iframe")
          }
          header.html(iframe);
          // header.find("a").addClass("d-none");
        }
      },
      error: function(response) {
        header.find("a").removeClass("d-none");
        alert('Something went wrong. Please try again.');
      }
    });
  }

  renderPost(){
    let post_id = $('#postId').val()
    let url = `/posts/${post_id}/render_post`

    if(post_id) {
      Rails.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        success: (response) => {
          $('#post_template').html(response)
        }
      })
    }
  }

  showCaptions(event) {
    $(".captions").addClass('d-none');
    $("#trascript-" + $(event.target).attr('id')).removeClass('d-none');
    $("#selected-caption").text($(event.target).text());
    $(".dropdown-item").removeClass("active");
    $(event.target).addClass("active");
  }

  getTextTranslation(event){
    event.preventDefault();
    let post_id = $(event.target).data("id");

    Rails.ajax({
      type: 'GET',
      url: `/posts/${post_id}/translate_text`,
      dataType: 'json',
      success: (response) => {
        let html = "<h6 class='ml-2 mt-1'>English Translation:</h6>"

        response.translations.forEach(function(str){
          html += `<div class="m-2">${str}</div>`
        });

        $(event.target).parents(".post-item.post-template").find(`#translation-div-${post_id}`).html(html) 
      },
      error: (response) => {
        console.log(response)
      }
    })
  }

  play1Video(event) {
    $('.post-videos').each(function() {
      var video = $(this).get(0);
      if(video.paused == false) {
        video.pause()
      }
    });
  }
}
